import { Entry } from "@/components/Product/Label/components/entry";
import { Base } from "@/components/Product/Label/label.base";

export const Label = Object.assign(Base, {
    Entry: Entry
});
